import React, { type FunctionComponent, useCallback } from 'react'
import { Radio } from 'ic-snacks'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { CollectionsFormSection } from 'domains/collections/components/collections-form/components/form-section/CollectionsFormSection'

export enum CollectionsContentType {
  rules = 'rules',
  childCollections = 'childCollections',
}

interface Props {
  onSelect: (contentType: CollectionsContentType) => void
  value: CollectionsContentType
}

const RadioWrapper = styled.div({
  marginRight: spacing.X32,
})

const RadioGroup = styled.div({
  paddingTop: spacing.X16,
  paddingBottom: spacing.X16,
  display: 'flex',
})

export const CollectionsContent: FunctionComponent<Props> = ({ onSelect, value }) => {
  const messages = useDomainMessages({
    ruleLabel: 'collectionsDomain.collectionsForm.content.type.rule',
    childCollectionsLabel: 'collectionsDomain.collectionsForm.content.type.childCollections',
  })

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newType = event.currentTarget.value as CollectionsContentType
      onSelect(newType)
    },
    [onSelect]
  )

  return (
    <CollectionsFormSection titleId="collectionsDomain.collectionsForm.content.title">
      <RadioGroup>
        <RadioWrapper>
          <Radio
            id="collections-form-content-rules"
            value={CollectionsContentType.rules}
            isSelected={value === CollectionsContentType.rules}
            onChange={onChange}
          >
            {messages.ruleLabel}
          </Radio>
        </RadioWrapper>
        <RadioWrapper>
          <Radio
            id="collections-form-content-child-collections"
            value={CollectionsContentType.childCollections}
            isSelected={value === CollectionsContentType.childCollections}
            onChange={onChange}
          >
            {messages.childCollectionsLabel}
          </Radio>
        </RadioWrapper>
      </RadioGroup>
    </CollectionsFormSection>
  )
}
